import { setWorkerUrl } from 'maplibre-gl';
import mapLibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

let isConfigured = false;

export function ensureMapLibreWorkerConfigured(): void {
  if (isConfigured) return;

  setWorkerUrl(mapLibreWorkerUrl);
  isConfigured = true;
}
